import { HeaderIcon } from 'components/mobile/organisms';
import { SlotComponentProps } from 'modules/page-builder/types';

export type HeaderRightItemProps = SlotComponentProps<{}>;

export const HeaderRightItemMobile: React.FC<HeaderRightItemProps> = ({}) => {
  return <HeaderIcon isVisible={true} isShowCartIcon />;
};
